/* euroguard · Filtro bajo encimera (Flow 1™) PDP — widget de dos planes y carrusel «Lo esencial».
   La galería, la barra fija y el resumen (data-eg-buy-add-price / data-eg-buy-summary) los gestiona
   pdp-faucet.js a través de los mismos atributos; aquí solo se rellenan sus valores.
   cfg.systemPlan (modo «plan del sistema»): la variante única lleva su propio selling_plan; hoy = precio del plan,
   luego = renovación del plan; el carrito recibe solo {id, quantity, selling_plan}. */
(() => {
'use strict';
if (window.__egUndersink) return; window.__egUndersink = true; // the script tag can appear once per section
const $ = (s, r = document) => r.querySelector(s);
const $$ = (s, r = document) => [...r.querySelectorAll(s)];

/* ---------- Widget de planes: Reposición automática / Compra única ---------- */
class PlansWidget {
  constructor(root) {
    this.root = root;
    try { this.config = JSON.parse($('[data-eg-uc-config]', root)?.textContent || '{}'); } catch (e) { console.error('eg-uc: invalid config', e); this.config = {}; }
    const cfg = this.config;
    if (!cfg.system || !(Number(cfg.system.oneVariantId) > 0)) return;
    this.sysPlan = cfg.systemPlan && Number(cfg.systemPlan.planId) > 0 && !(Number(cfg.system.subVariantId) > 0) ? cfg.systemPlan : null;
    this.subAvailable = !!(cfg.cartridge && Number(cfg.system.subVariantId) > 0) || !!this.sysPlan;
    this.mode = cfg.defaultMode === 'sub' && this.subAvailable ? 'sub' : 'one';
    this.cards = $$('[data-eg-uc-card]', root);
    this.addButtons = $$('[data-eg-buy-add]');
    this.error = $('[data-eg-uc-error]', root);
    this.status = $('[data-eg-uc-status]', root);
    this.fmt = new Intl.NumberFormat(cfg.locale || 'fr-FR', { style: 'currency', currency: cfg.currency || 'EUR' });
    this.cards.forEach(card => $('[data-eg-uc-toggle]', card)?.addEventListener('click', () => this.setMode(card.dataset.egUcCard)));
    this.addButtons.forEach(btn => btn.addEventListener('click', () => this.add()));
    this.render();
  }
  money(cents) { return this.fmt.format((Number(cents) || 0) / 100); }
  price(mode) {
    const s = this.config.system, c = this.config.cartridge;
    if (mode === 'sub' && this.sysPlan) {
      const total = Number(this.sysPlan.price);
      const compare = Number(s.onePrice) > total ? Number(s.onePrice) : 0;
      return { total, compare, saving: compare ? compare - total : 0, renew: Number(this.sysPlan.renew), months: Number(this.sysPlan.months) || 12 };
    }
    if (mode === 'sub' && this.subAvailable) {
      const total = Number(s.subPrice) + Number(c.price);
      const compare = Number(s.onePrice) > total ? Number(s.onePrice) : 0;
      return { total, compare, saving: compare ? compare - total : 0, renew: Number(c.price), months: Number(c.months) || 12 };
    }
    const total = Number(s.onePrice);
    const compare = Number(s.oneCompare) > total ? Number(s.oneCompare) : 0;
    return { total, compare, saving: 0, renew: 0, months: 0 };
  }
  setMode(mode) {
    if (mode === 'sub' && !this.subAvailable) return;
    if (mode && mode !== this.mode) { this.mode = mode; if (this.error) this.error.hidden = true; this.render(); }
  }
  render() {
    const cfg = this.config, L = cfg.labels || {}, mode = this.mode, p = this.price(mode);
    this.cards.forEach(card => {
      const m = card.dataset.egUcCard, active = m === mode, pm = this.price(m);
      card.classList.toggle('is-active', active);
      $('[data-eg-uc-toggle]', card)?.setAttribute('aria-expanded', String(active));
      const head = $(`[data-eg-uc-head-price="${m}"]`, card); if (head) head.textContent = this.money(pm.total);
      const hc = $(`[data-eg-uc-head-compare="${m}"]`, card); if (hc) { hc.hidden = !pm.compare; hc.textContent = pm.compare ? this.money(pm.compare) : ''; }
      const bullets = m === 'sub' ? cfg.subBullets : cfg.oneBullets;
      $$(`[data-eg-uc-bullets="${m}"] li`, card).forEach((li, i) => { const t = String((bullets || [])[i] || '').trim(); li.hidden = !t; if (t) $('span', li).textContent = t; });
    });
    const sys = $('[data-eg-uc-system-price="sub"]', this.root); if (sys) sys.innerHTML = `<span class="is-sub">${this.money(this.sysPlan ? this.sysPlan.price : cfg.system.subPrice)}</span>`;
    const sysOne = $('[data-eg-uc-system-price="one"]', this.root); if (sysOne) sysOne.innerHTML = this.money(cfg.system.onePrice) + (this.price('one').compare ? `<s>${this.money(cfg.system.oneCompare)}</s>` : '');
    const cart = $('[data-eg-uc-cartridge-price]', this.root);
    if (cart && this.sysPlan) { const ps = this.price('sub'); cart.innerHTML = `${this.money(ps.renew)}<small>${String(L.perMonths || 'tous les [meses] mois').replace('[meses]', ps.months)}</small>`; }
    else if (cart && cfg.cartridge) cart.innerHTML = `${this.money(cfg.cartridge.price)}<small>${L.todayNote || 'aujourd\'hui'}</small>`;
    $$('[data-eg-uc-total]', this.root).forEach(el => el.innerHTML = this.money(p.total) + (p.compare ? `<s>${this.money(p.compare)}</s>` : ''));
    $$('[data-eg-uc-total-note]', this.root).forEach(el => {
      if (mode === 'sub') {
        const every = String(L.perMonths || 'tous les [meses] mois').replace('[meses]', p.months);
        const parts = [];
        if (p.saving > 0) parts.push(`<b>${L.saving || 'Vous économisez'} ${this.money(p.saving)}</b> ${L.vsOneTime || 'par rapport à l\'achat unique'}`);
        parts.push(`${L.then || 'Ensuite'} ${this.money(p.renew)} ${every}`);
        el.innerHTML = parts.join('<br>');
      } else el.textContent = L.oneNote || '';
    });
    $$('[data-eg-buy-add-price]').forEach(el => el.textContent = this.money(p.total));
    $$('[data-eg-buy-add-label]').forEach(el => el.textContent = L.add || 'Ajouter au panier');
    $$('[data-eg-buy-add-extra]').forEach(el => el.textContent = mode === 'sub' ? (L.addSub || '') : '');
    $$('[data-eg-buy-summary]').forEach(el => el.textContent = mode === 'sub' ? (L.summarySub || 'Réapprovisionnement automatique') : (L.summaryOne || 'Achat unique'));
    this.root.dispatchEvent(new CustomEvent('eg-uc:change', { bubbles: true, detail: { mode, price: p } }));
  }
  items() {
    const cfg = this.config, L = cfg.labels || {}, label = L.purchaseOption || 'Formule';
    const group = 'eg-offer-' + (window.crypto?.randomUUID ? crypto.randomUUID() : Date.now().toString(36));
    const base = { _offer_source: 'eg-pdp-undersink', _offer_group: group };
    if (this.mode === 'sub' && this.sysPlan) return [{ id: Number(cfg.system.oneVariantId), quantity: 1, selling_plan: Number(this.sysPlan.planId) }];
    if (this.mode === 'sub') {
      const title = $('[data-eg-uc-card="sub"] .eg-buy__title strong', this.root)?.textContent.trim() || 'Réapprovisionnement automatique';
      return [
        { id: Number(cfg.system.subVariantId), quantity: 1, properties: Object.assign({ _offer_role: 'main', _offer_requires_sub: '1' }, base, { [label]: title }) },
        { id: Number(cfg.cartridge.variantId), quantity: 1, selling_plan: Number(cfg.cartridge.plan), properties: Object.assign({ _offer_role: 'addon' }, base, { [label]: title }) },
      ];
    }
    const title = $('[data-eg-uc-card="one"] .eg-buy__title strong', this.root)?.textContent.trim() || 'Achat unique';
    return [{ id: Number(cfg.system.oneVariantId), quantity: 1, properties: { [label]: title } }];
  }
  async add() {
    if (this.busy) return;
    const cfg = this.config, L = cfg.labels || {};
    if (this.mode === 'sub' && !(this.sysPlan ? Number(this.sysPlan.planId) > 0 : Number(cfg.cartridge?.plan) > 0)) {
      if (this.error) { this.error.textContent = L.noPlan || 'Le réapprovisionnement automatique n\'est pas disponible pour le moment. Choisissez l\'achat unique ou réessayez plus tard.'; this.error.hidden = false; }
      return;
    }
    const items = this.items(); if (!items.length) return;
    this.busy = true; this.addButtons.forEach(b => { b.disabled = true; b.setAttribute('aria-busy', 'true'); });
    if (this.error) this.error.hidden = true;
    try {
      const res = await fetch(cfg.addUrl || '/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, credentials: 'same-origin', body: JSON.stringify({ items }) });
      const data = await res.json().catch(() => ({}));
      if (!res.ok || data.status) throw new Error(data.description || data.message || 'add failed');
      if (this.status) this.status.textContent = L.added || 'Ajouté au panier';
      if (window.egCartDrawer) { // carrito lateral: se abre sin salir de la página
        this.busy = false; this.addButtons.forEach(b => { b.disabled = false; b.removeAttribute('aria-busy'); });
        document.dispatchEvent(new CustomEvent('cart:refresh', { detail: { open: true, items } }));
      } else {
        document.dispatchEvent(new CustomEvent('cart:refresh'));
        location.href = cfg.cartUrl || '/cart';
      }
    } catch (e) {
      console.error(e);
      if (this.error) { this.error.textContent = L.error || 'Impossible d\'ajouter au panier. Veuillez réessayer.'; this.error.hidden = false; }
      this.busy = false; this.addButtons.forEach(b => { b.disabled = false; b.removeAttribute('aria-busy'); });
    }
  }
}

/* ---------- Carrusel «Lo esencial» ---------- */
function initHighlights(root) {
  const track = $('[data-eg-highlights-track]', root), prev = $('[data-eg-highlights-prev]', root), next = $('[data-eg-highlights-next]', root);
  if (!track) return;
  const step = () => { const card = track.firstElementChild; return card ? card.getBoundingClientRect().width + 16 : 320; };
  const update = () => {
    const max = track.scrollWidth - track.clientWidth - 2;
    if (prev) prev.disabled = track.scrollLeft <= 2;
    if (next) next.disabled = track.scrollLeft >= max;
  };
  const smooth = matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';
  prev?.addEventListener('click', () => track.scrollBy({ left: -step(), behavior: smooth }));
  next?.addEventListener('click', () => track.scrollBy({ left: step(), behavior: smooth }));
  track.addEventListener('scroll', () => requestAnimationFrame(update), { passive: true });
  track.addEventListener('keydown', e => { if (e.key === 'ArrowRight') { e.preventDefault(); next?.click(); } else if (e.key === 'ArrowLeft') { e.preventDefault(); prev?.click(); } });
  window.addEventListener('resize', update);
  update();
}

function init() {
  $$('[data-eg-buy-uc]').forEach(el => { if (!el.dataset.ucReady) { el.dataset.ucReady = '1'; new PlansWidget(el); } });
  $$('[data-eg-highlights]').forEach(el => { if (!el.dataset.hlReady) { el.dataset.hlReady = '1'; initHighlights(el); } });
}
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
document.addEventListener('shopify:section:load', init);
})();
